import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mqtt from '@/utils/mqtt'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css';
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import '@/styles/common.css'
//import '@/icons' // icon
Vue.config.productionTip = false
Vue.use(ElementUI)

// 全局引用websocket
Vue.prototype.$mqtt = mqtt

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
